// wordSeparator.js

function separateWords(inputString) {
  const wordsArray = inputString.split(/(?=[A-Z])|[-_ ]+/);
  const separatedWords = wordsArray.join(" ");
  return separatedWords;
}

module.exports = separateWords;
